<div class="survey-overlay" role="dialog" aria-modal="true" aria-labelledby="review-prompt-title">
  <div class="survey-modal" (click)="$event.stopPropagation()">
    <div class="close-container">
      <button type="button" class="close-btn" (click)="close()" aria-label="Cerrar">
        <lucide-icon name="X" [size]="20"></lucide-icon>
      </button>
    </div>

    <div class="play-store-prompt">
      @if (decodedEmoji()) {
        <div class="play-store-emoji" aria-hidden="true">{{ decodedEmoji() }}</div>
      }

      <h2 id="review-prompt-title" class="play-store-title">¡Gracias por tu valoración!</h2>

      @if (googleReviewSentence()) {
        <p class="play-store-description">
          {{ googleReviewSentence() }}
        </p>
      }

      <div class="play-store-actions">
        @if (showGoogleCta()) {
          <p-button
            label="Dejar reseña en Google"
            severity="primary"
            [style]="{ width: '100%' }"
            (onClick)="openGoogleReview()"
          >
          </p-button>
        }

        <p-button
          [label]="showGoogleCta() ? 'Ahora no' : 'Cerrar'"
          severity="secondary"
          [outlined]="true"
          styleClass="play-store-dismiss-btn"
          [style]="{ width: '100%' }"
          (onClick)="close()"
        >
        </p-button>
      </div>
    </div>
  </div>
</div>
